/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeModal, switchModal } from '../../actions';
import X from '../../assets/login/x.svg';

const Success = (props) => {
  const renderSubHeader = () => {
    let string = '';
    if (props.origin === 'forgot') {
      string = 'A password reset email has been successfully sent! Click the link in the email to reset your password.';
    } else if (props.origin === 'reset') {
      string = 'Your password has been successfully reset! You can now login with this new password.';
    }
    return <p className="modal-success-text">{string}</p>;
  };

  const renderButton = () => {
    if (props.origin === 'forgot') {
      return (
        <div className="sign-in-bubble">
          <input type="button"
            value="Close"
            className="sign-in-button"
            onClick={() => {
              props.closeModal();
            }}
          />
        </div>
      );
    } else if (props.origin === 'reset') {
      return (
        <div className="sign-in-bubble">
          <input type="button"
            value="Log in"
            className="sign-in-button"
            onClick={() => {
              props.switchModal('SignIn');
            }}
          />
        </div>
      );
    } else {
      return (
        <div className="sign-in-bubble">
          <input type="button"
            value="Continue to Survey"
            className="sign-in-button long-button"
            onClick={() => {
              props.closeModal();
              props.history.push('/dashboard');
            }}
          />
        </div>
      );
    }
  };

  return (
    <div className="modal success-background">
      <img className="x-icon" onClick={props.closeModal} src={X} alt="x" />
      <div className="success-container">
        <div>
          <p className="success-header" style={{ margin: 0 }}>Success!</p>
          {renderSubHeader()}
        </div>
        {renderButton()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    origin: state.modal.endPage,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal })(withRouter(Success));
